import { render } from "./PanelModal.vue?vue&type=template&id=70c70df7&scoped=true"
import script from "./PanelModal.vue?vue&type=script&lang=js"
export * from "./PanelModal.vue?vue&type=script&lang=js"

import "./PanelModal.vue?vue&type=style&index=0&id=70c70df7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c70df7"]])

export default __exports__